import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router';

import { ROUTES } from '@utils/routes';

import { getUrlToBackendApi, request } from '@services/api';

import { UserType } from '@types';

const REQUEST_URL = '/me';

export const GET_ME_QUERY_KEY = ['user', 'me'];

export const useQueryGetMe = () => {
	const navigate = useNavigate();
	return useQuery<unknown, unknown, UserType>({
		queryKey: GET_ME_QUERY_KEY,
		queryFn: async () => {
			try {
				const res = await request<UserType>({
					method: 'get',
					url: getUrlToBackendApi(REQUEST_URL).href
				});

				if (res) {
					if (res.pm_id && !res.onboarding_passed) {
						navigate(ROUTES.WELCOME);
					}

					return res;
				}

				throw new Error(`Unexpected status: `);
			} catch (error: any) {
				if (error.data?.status === 'error') {
					return null;
				}

				throw error;
			}
		},
		refetchOnWindowFocus: false,
		retry: false
	});
};
